import { ReactElement } from 'react';

import { useMaintenance } from 'hooks';

import MaintenanceModeModal from 'components/maintenanceModal';
import { useSearchParams } from 'react-router-dom';

const prod = 'avax-dex.cables.finance';
const host = window.location.host;

const WithMaintenanceMode = ({ children }: { children: ReactElement }) => {
  const { isMaintenance, maintenanceMessage } = useMaintenance();
  const [searchParams, setSearchParams] = useSearchParams();

  if (!isMaintenance) {
    return children;
  } else {
    if (searchParams.get('maintenance') === 'false' && host !== prod) {
      return children;
    }
  }

  return <MaintenanceModeModal message={maintenanceMessage} />;
};

export default WithMaintenanceMode;
